import { designService } from '@paragon/data-connections';

import { requireString } from './helpers';
import { defineTool, ToolError } from './types';

/** The problem DesignServer sent, as a ToolError the model can read. */
function docsError(what: string, error: unknown) {
  const detail = (error as { detail?: unknown } | null)?.detail;
  return new ToolError(`Paragon Docs couldn't be ${what}${typeof detail === 'string' ? `: ${detail}` : '.'}`);
}

export const docsTools = [
  defineTool<{ query: string }>({
    name: 'search_paragon_docs',
    description:
      'Searches Paragon Docs (docs.paragontruss.com), the user guide and Training Academy, and gives the best-matching ' +
      'pages with a link and an excerpt of each. Use it when the designer asks how to do something in Paragon, what ' +
      'a setting or feature does, or where to learn more, and link the pages you answer from. Search with a few ' +
      'words, such as "horizontal blocking gable" or "import DXF walls".',
    inputSchema: { type: 'object', properties: { query: { type: 'string' } }, required: ['query'] },
    changesProject: false,
    async execute(input) {
      const query = requireString(input, 'query');
      let pages;
      try {
        pages = await designService.assistant.searchDocs(query);
      } catch (error) {
        throw docsError('searched', error);
      }
      return {
        summary:
          pages.length === 0
            ? { pages, note: `Nothing in Paragon Docs matched "${query}". Try other words.` }
            : { pages },
      };
    },
  }),
  defineTool<{ link: string }>({
    name: 'read_paragon_docs_page',
    description:
      'Reads the whole of a Paragon Docs page, in Markdown, by a link search_paragon_docs gave. Use it when an ' +
      "excerpt stops short of what you need, such as a how-to's steps.",
    inputSchema: { type: 'object', properties: { link: { type: 'string' } }, required: ['link'] },
    changesProject: false,
    async execute(input) {
      const link = requireString(input, 'link');
      try {
        return { summary: await designService.assistant.readDocsPage(link) };
      } catch (error) {
        throw docsError('read', error);
      }
    },
  }),
];
